import { __decorate } from "tslib";
import React from 'react';
import PropTypes from 'prop-types';
import { action, runInAction } from 'mobx';
import { observer } from 'mobx-react';
import { Radio } from '../radio/Radio';
import { BooleanValue } from '../data-set/enum';
export class CheckBox extends Radio {
    constructor(props, context) {
        super(props, context);
        this.type = 'checkbox';
        runInAction(() => {
            this.value = this.props.defaultChecked ? this.checkedValue : this.unCheckedValue;
        });
    }
    get unCheckedValue() {
        const { unCheckedValue } = this.props;
        if (unCheckedValue !== undefined) {
            return unCheckedValue;
        }
        const { field } = this;
        if (field) {
            return field.get(BooleanValue.falseValue);
        }
        return false;
    }
    get checkedValue() {
        const { value } = this.props;
        if (value !== undefined) {
            return value;
        }
        const { field } = this;
        if (field) {
            return field.get(BooleanValue.trueValue);
        }
        return true;
    }
    getOmitPropsKeys() {
        return super.getOmitPropsKeys().concat([
            'defaultChecked',
            'unCheckedValue',
            'unCheckedChildren',
            'indeterminate',
        ]);
    }
    renderInner() {
        return React.createElement("i", { className: `${this.prefixCls}-inner` });
    }
    getChildrenText() {
        const { children, unCheckedChildren } = this.props;
        return this.isChecked() ? children : unCheckedChildren || children;
    }
    getWrapperClassNames() {
        const { prefixCls, props: { indeterminate }, } = this;
        return super.getWrapperClassNames({
            [`${prefixCls}-indeterminate`]: indeterminate,
        });
    }
    isChecked() {
        const { checked, indeterminate } = this.props;
        if (indeterminate) {
            return false;
        }
        const { name, dataSet, checkedValue } = this;
        if (!this.isControlled && dataSet && name) {
            return this.getValues().indexOf(checkedValue) !== -1;
        }
        if (checked !== undefined) {
            return checked;
        }
        return this.value === checkedValue;
    }
    getDataSetValues() {
        const values = this.getDataSetValue();
        if (values === undefined) {
            return [];
        }
        return [].concat(values);
    }
    setValue(value, noVaidate) {
        const { record, checkedValue, multiple } = this;
        if (record) {
            let values;
            if (multiple) {
                values = this.getValues();
                if (value === checkedValue) {
                    values.push(value);
                }
                else {
                    const index = values.indexOf(checkedValue);
                    if (index !== -1) {
                        values.splice(index, 1);
                    }
                }
            }
            else {
                values = value;
            }
            super.setValue(values, noVaidate);
        }
        else {
            super.setValue(value, noVaidate);
        }
    }
    setChecked(checked) {
        this.setValue(checked ? this.checkedValue : this.unCheckedValue);
    }
    getOldValue() {
        return this.isChecked() ? this.checkedValue : this.unCheckedValue;
    }
}
CheckBox.displayName = 'CheckBox';
CheckBox.propTypes = {
    /**
     * 中间状态
     */
    indeterminate: PropTypes.bool,
    /**
     * 未选中时的值
     */
    unCheckedValue: PropTypes.any,
    /**
     * 未选中时的内容
     */
    unCheckedChildren: PropTypes.node,
    ...Radio.propTypes,
};
/**
 * tooltip disable sign
 */
// eslint-disable-next-line camelcase
CheckBox.__PRO_CHECKBOX = true;
// eslint-disable-next-line camelcase
CheckBox.__IS_IN_CELL_EDITOR = true;
CheckBox.defaultProps = {
    ...Radio.defaultProps,
    suffixCls: 'checkbox',
    indeterminate: false,
};
__decorate([
    action
], CheckBox.prototype, "setValue", null);
__decorate([
    action
], CheckBox.prototype, "setChecked", null);
let ObserverCheckBox = class ObserverCheckBox extends CheckBox {
};
ObserverCheckBox.defaultProps = CheckBox.defaultProps;
// eslint-disable-next-line camelcase
ObserverCheckBox.__PRO_CHECKBOX = true;
// eslint-disable-next-line camelcase
ObserverCheckBox.__IS_IN_CELL_EDITOR = true;
ObserverCheckBox = __decorate([
    observer
], ObserverCheckBox);
export default ObserverCheckBox;
